import React from 'react';
import { List, Descriptions } from 'antd';
import cn from 'classnames';
import classes from './Style.module.scss';

export default function SupplierListItem(props) {
  const {
    name,
    address,
    contactPerson,
    contactPersonPhone,
    emails,
    supplierId,
    children = null,
    extra,
    className,
    hideEmail,
    hideContactPerson,
    hideContactNo, //Contact person phone
    bordered = true
  } = props;
  return (
    <List.Item className={cn(classes.supplier, className)}>
      <div className={classes.content}>
        <div
          className={cn(classes.description, {
            [classes.bordered]: bordered
          })}
        >
          <Descriptions title={name}>
            {[
              {
                label: 'Supplier ID',
                span: 3,
                children: supplierId || 'N/A'
              },
              {
                label: 'Address',
                span: 3,
                children: address || 'N/A'
              },
              {
                label: 'Contact Person',
                span: 3,
                children: contactPerson || 'N/A'
              },
              {
                label: 'Contact no.',
                span: 3,
                children: contactPersonPhone || 'N/A'
              },
              {
                label: 'Email',
                span: 3,
                children:
                  Array.isArray(emails) && emails.length
                    ? emails.map(({ email }) => email).join(', ')
                    : 'N/A'
              }
            ]
              .filter((item) => {
                if (item.label === 'Email' && hideEmail) {
                  return false;
                }
                if (item.label === 'Contact Person' && hideContactPerson) {
                  return false;
                }
                if (item.label === 'Contact no.' && hideContactNo) {
                  return false;
                }
                return true;
              })
              .map((item, index) => {
                return (
                  <Descriptions.Item
                    key={index}
                    label={item.label}
                    span={item.span}
                  >
                    {item.children}
                  </Descriptions.Item>
                );
              })}
          </Descriptions>
          {extra}
        </div>
        {children}
      </div>
    </List.Item>
  );
}

// SupplierListItem.propTypes = {
//   emails: PropTypes.arrayOf(PropTypes.shape({ email: PropTypes.string })),
//   address: PropTypes.string,
//   name: PropTypes.string,
//   contactPerson: PropTypes.string,
//   supplierId: PropTypes.string,
//   bordered: PropTypes.bool,
//   extra: PropTypes.node,
//   children: PropTypes.node,
//   className: PropTypes.string,
//   hideEmail: PropTypes.bool,
//   hideContactPerson: PropTypes.bool,
// };

// SupplierListItem.defaultProps = {
//   emails: [], // Add defaultProps for the 'emails' prop
//   bordered: true,
//   extra: null,
//   children: null,
//   className: '',
//   address: '',
//   name: '',
//   contactPerson: '',
//   supplierId: '',
//   hideEmail: false,
//   hideContactPerson: false,
// };
